import config from '../config';

export async function fetchElionBoxStatus(){
    const response = await fetch(config.REACT_APP_STATUS_API_URL + '/status/elion/box')
    const res = await response.json();
    return res;
}